module.exports = __webpack_public_path__ + "img/prizeRule.b1d754e2.jpg";